import React from 'react';
import Card from '@material-ui/core/Card';

export default class NoMatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
    };
    // props.setActiveComponent('No-Match');
  }

  render() {
    return (
      <Card id="no-match" raised>
        <div className="no-match-title">Page Not Found</div>
      </Card>
    );
  }
}
